import React from 'react';
import { IconChevronDown, IconChevronRight, IconChevronUp } from '@punchcard/core/icons';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useActivityStatusMapping, useStatusCodeMappingLesson } from '@punchcard/core/utils/statusMappingConfig';
interface IProps {
	gradeValue: number | undefined,
	gradeReceived: number | undefined,
	workbookStatus: string,

	handleWorkbookClick?: () => void,
}

function WorkbookCompletionAccordionSummary({
	gradeValue,
	gradeReceived,
	workbookStatus,
	handleWorkbookClick,
}: IProps) {
	const [isActive, setIsActive] = React.useState<boolean>(false);
	const lessonStatusMap = useStatusCodeMappingLesson();
	const activityStatusMap = useActivityStatusMapping();
	const statusConfig = lessonStatusMap[workbookStatus] || {};
	const IconComponent = statusConfig.icon;
	const { t } = useTranslation();

	React.useEffect(() => {
		if (gradeValue) {
			const open = gradeValue !== undefined && gradeValue !== 0;
			setIsActive(open);

		}
	}, [gradeValue]);


	return (
		<div className="mb-2">
			<button
				className={classNames('lesson-accordion', { 'active': isActive })}
				onClick={() => setIsActive(!isActive)}
			>
				<div className="d-flex align-items-c enter flex-grow-1 overflow-hidden">
					<div className="d-flex align-items-center flex-shrink-0">
						{isActive ? <IconChevronUp style={{ width: 18, height: 18 }} className="me-2" /> : <IconChevronDown style={{ width: 18, height: 18 }} className="me-2" />}
						{IconComponent && <IconComponent
							style={{ width: 18, height: 18 }}
							className={classNames('me-2', { [statusConfig.className]: !isActive, [statusConfig.activeIconClassName ?? '']: isActive })}
						/>}
					</div>
					<div className="text-truncate flex-grow-1 text-start">
						{t('wip.workbook_completion')}
					</div>
				</div>
			</button>
			{isActive && (
				<div className="lesson-accordion-content border border-quaternary-800 rounded-bottom-3">
					<button
						className={classNames('activity', { 'active': isActive })}
						onClick={() => handleWorkbookClick && handleWorkbookClick()}
					>
						<div className="d-flex align-items-center flex-grow-1 overflow-hidden">
							<div className="d-flex align-items-center flex-shrink-0">
								{IconComponent && <IconComponent style={{ width: 18, height: 18 }} className={classNames('me-2', statusConfig.className)} />}
							</div>
							<div className="text-truncate flex-grow-1 text-start">
								{t('wip.workbook_completion')}
							</div>
						</div>
						<span className={
							classNames('status ms-3 flex-shrink-0',
								isActive ? activityStatusMap[workbookStatus]?.activeClassName : statusConfig.className,
								{ 'text-decoration-underline': activityStatusMap[workbookStatus]?.clickable && !isActive }
							)
						}>
							{isActive && (
								<div className="d-flex align-items-center">
									{gradeReceived ?? '__'}/{gradeValue}
								</div>
							)}
							{activityStatusMap[workbookStatus]?.clickable && !isActive && (
								<IconChevronRight className={`ms-1 ${statusConfig.className}`} style={{ width: 18, height: 18 }} />
							)}
						</span>
					</button>



				</div>)
			}
		</div>
	);
}

export default WorkbookCompletionAccordionSummary;